import React from 'react';

const UndoIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 21c0 .274.225.5.5.5s.5-.226.5-.5v-5.501a2.5 2.5 0 0 0-2.5-2.5H8.705l3.147-3.148a.502.502 0 0 0 0-.706.502.502 0 0 0-.706 0l-4 4a.502.502 0 0 0 0 .707l4 4a.502.502 0 0 0 .706 0 .502.502 0 0 0 0-.706l-3.147-3.147H20.5a1.5 1.5 0 0 1 1.5 1.5v5.5z"
        fill="currentColor"
      />
    </svg>
  );
};

export default UndoIcon;
